import { FilterApplications } from './filter-applications.model';

export class ApplicationsFilter {
  fields: FilterApplications;
  id?: number;
  isDefault: boolean;
  isFavorite: boolean;
  name: string;
}
